import { jsx as f } from "react/jsx-runtime";
import { c as N } from "../index-Cu0xwYjD.js";
import * as c from "react";
import { fontWeightToClassName as i, fontSizeToClassName as T, fontColorToClassName as x, textAlignToClassName as C } from "./Props.js";
const d = c.forwardRef(
  ({
    children: a,
    className: o,
    weight: s,
    // NOTE: The default font-size is supposed to be 14px but we never set that
    // so all apps have been using 16px if the size was undefined
    size: e,
    color: t,
    align: m,
    node: r,
    ...n
  }, p) => {
    const l = b(r);
    return /* @__PURE__ */ f(
      l,
      {
        ref: p,
        ...n,
        className: N(
          o,
          s && i[s],
          e && T[e],
          t && x[t],
          m && C[m]
        ),
        children: a
      }
    );
  }
);
d.displayName = "Text";
const b = (a) => ({
  span: "span",
  label: "label"
})[a ?? "span"];
export {
  d as Text
};
